export enum RULE_RESULT {
  GREY = 'GREY',
  GREEN = 'GREEN',
  RED = 'RED',
  YELLOW = 'YELLOW',
}

// Define only the rules that are evaluated for dynamic data
export enum ASSESSMENT_INSIGHTS_RULE_FOR_DYNAMIC_DATA {
  BSCRE1 = 'bscre1',
  BSCRE2 = 'bscre2',
  CNM = 'cnm',
  DED = 'ded',
  EM = 'em',
  ESM = 'esm',
  IV_PS = 'iv-ps',
  RPC = 'rpc',
  TV = 'tv',
}

export type AssessmentInsightsResult = Record<ASSESSMENT_INSIGHTS_RULE_FOR_DYNAMIC_DATA, RULE_RESULT>
